import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { currentRolePermissionsSelector } from '@selectors/role';
import { FeaturePermissionEntityInterface, PagePermissionEntityInterface } from '@types';
import _cloneDeep from 'lodash/cloneDeep';

export const useGetCurrentRolePermissions = (
  pagePermission: PagePermissionEntityInterface,
  currentFeaturePermission?: FeaturePermissionEntityInterface
) => {
  const currentRolePermissions = useSelector(currentRolePermissionsSelector);
  return useMemo(() => {
    if (!currentRolePermissions) {
      return false;
    }
    return getUpdatedRolePermissions(
      _cloneDeep(currentRolePermissions),
      _cloneDeep(pagePermission),
      _cloneDeep(currentFeaturePermission)
    );
  }, [pagePermission, currentFeaturePermission]);
};

const getUpdatedRolePermissions = (
  newRolePermissions: PagePermissionEntityInterface[],
  currentPagePermission: PagePermissionEntityInterface,
  currentFeaturePermission: FeaturePermissionEntityInterface
) => {
  const pagePermissionIndex = newRolePermissions.findIndex((pagePermission) => {
    return pagePermission.name === currentPagePermission.name;
  });

  if (pagePermissionIndex !== -1) {
    if (!currentFeaturePermission) {
      newRolePermissions[pagePermissionIndex] = currentPagePermission;
    }
    if (currentFeaturePermission) {
      const currentFeaturePermissionIndex = currentPagePermission.featurePermissions.findIndex(
        (featurePermission) => {
          return featurePermission.id === currentFeaturePermission.id;
        }
      );
      newRolePermissions[pagePermissionIndex].featurePermissions[currentFeaturePermissionIndex] =
        currentFeaturePermission;
    }
  }

  return newRolePermissions;
};
